import React, { useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function GoogleButton(props) {
  const {
    buttonConfiguration
  } = props;
  const [btnEl, setBtnEl] = useState(null);
  const propsRef = useRef(props);
  propsRef.current = props;
  useEffect(() => {
    if (!btnEl) {
      return;
    }
    const existingScript = document.getElementById('googleClient');
    const initGoogleClient = () => {
      var _window$google;
      if ((_window$google = window.google) !== null && _window$google !== void 0 && (_window$google = _window$google.accounts) !== null && _window$google !== void 0 && _window$google.id) {
        var _propsRef$current$but;
        window.google.accounts.id.initialize({
          client_id: propsRef.current.googleClientId,
          use_fedcm_for_prompt: true,
          callback: propsRef.current.callback
        });
        window.google.accounts.id.renderButton(btnEl, (_propsRef$current$but = propsRef.current.buttonConfiguration) !== null && _propsRef$current$but !== void 0 ? _propsRef$current$but : {
          type: 'standard'
        });
      }
    };
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.id = 'googleClient';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      script.onload = initGoogleClient;
    } else {
      existingScript.onload = initGoogleClient; // In case we found the script but it hasn't loaded yet.
      initGoogleClient(); // In case we found the script and it already loaded.
    }
  }, [btnEl, buttonConfiguration]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      ref: setBtnEl
    })
  });
}